/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alarm': {
    width: 19,
    height: 20,
    viewBox: '0 0 19 20',
    data: '<path pid="0" d="M2.563 16.642c0 .312.253.565.565.565H15.05a.565.565 0 00.565-.565v-6.626A6.478 6.478 0 0013.704 5.4 6.492 6.492 0 009.089 3.49a6.478 6.478 0 00-4.614 1.912 6.488 6.488 0 00-1.912 4.615v6.626zm1.13-6.626a5.402 5.402 0 015.396-5.397 5.402 5.402 0 015.397 5.397v6.06H3.693v-6.06zm14.4 8.854H.565a.565.565 0 000 1.13h17.53a.565.565 0 10-.002-1.13zM9.893.565a.565.565 0 00-1.13 0v1.471h1.13V.565zm6.41 3.706l1.112-1.112a.565.565 0 10-.8-.8l-1.112 1.112.8.8zm-13.89.215l.8-.8-1.111-1.112a.565.565 0 10-.8.8l1.112 1.112zm8.242 5.424H8.391l.97-2.007a.566.566 0 00-1.017-.493L6.98 10.228a.566.566 0 00.508.811h2.147l-1.324 2.12a.567.567 0 00.477.866.567.567 0 00.479-.265l1.866-2.983a.567.567 0 00-.479-.867z" _fill="#EC102D" fill-rule="nonzero"/>'
  }
})
